import { PDFForms } from '@models/matter-form-data';
import { PDFFormType } from '@models/matter-form-data';

export const getFormUrl = (formId: PDFFormType, withBasePath = true) => {
	return (withBasePath ? '/assets/pdf/' : '') + (PDFForms[formId].url ?? '');
};

export const getPdfForm = (formId: PDFFormType) => {
	return PDFForms[formId];
};
